import React from "react";
import { BottomToolbarComponent, BottomToolbarController } from "../../library/cms/page-components";
import { MDCBottomBar, MDCButtonIcon, MDCFabButton, MDCSnackBar, MDCDialog } from "../../library/components/mdc-components";
import { ActionsMenu, PageCreate, PageSettings } from "../../library/cms/page-components";
import PagesMenu from "./menu"; //page toolbar component

export class PageToolbar extends BottomToolbarComponent {
  constructor(props) {
    super(props);
  }

  render() {
    var mode = this.props.mode;
    var hidePublishCss = 'hide';
    var hideToggleCss = 'hide';
    var hideActions = false;
    var showFullActionsMenu = false;
    var showFullPagesMenu = false;
    var showSettings = false;

    switch (mode) {
      case 'CompletePages':
        hideActions = true;
        showFullPagesMenu = true;
        hidePublishCss = '';
        hideToggleCss = '';
        showSettings = true;
        break;

      case 'PartialPages':
        hideActions = true;
        break;

      case 'PartialPagesPublish':
        hideActions = true;
        hidePublishCss = '';
        hideToggleCss = '';
        showSettings = true;
        break;

      case 'PartialPagesPublishWithActions':
        hidePublishCss = '';
        hideToggleCss = '';
        showSettings = true;
        break;

      case 'CompleteActions':
        showFullActionsMenu = true;
        hidePublishCss = '';
        hideToggleCss = '';
        break;

      case 'CompleteActionsNoToggle':
        showFullActionsMenu = true;
        hidePublishCss = '';
        break;

      case 'PartialActions':
        //nothing
        break;

      case 'PartialActionsToggle':
        hideToggleCss = '';
        break;
    }

    return /*#__PURE__*/React.createElement(MDCBottomBar, {
      active: this.props.active
    }, /*#__PURE__*/React.createElement(MDCButtonIcon, {
      cls: hideToggleCss,
      icon: "visibility_off",
      label: "Toggle",
      active: this.getActiveState(0),
      onButtonClick: this.onClick.bind(this),
      index: "0",
      id: "toggle"
    }), /*#__PURE__*/React.createElement(PagesMenu, {
      active: this.getActiveState(1),
      showFullMenu: showFullPagesMenu,
      showSettings: showSettings,
      onMenuSelected: this.onMenuSelected.bind(this)
    }), /*#__PURE__*/React.createElement(ActionsMenu, {
      active: this.getActiveState(2),
      hide: hideActions,
      showFullMenu: showFullActionsMenu,
      onMenuSelected: this.onMenuSelected.bind(this)
    }), /*#__PURE__*/React.createElement(MDCButtonIcon, {
      cls: hidePublishCss,
      icon: "publish",
      label: "Publish",
      active: this.getActiveState(2),
      onButtonClick: this.onClick.bind(this),
      index: "2",
      id: "publish"
    }), /*#__PURE__*/React.createElement(MDCButtonIcon, {
      icon: "exit_to_app",
      label: "Exit",
      active: this.getActiveState(-2),
      onButtonClick: this.onClick.bind(this),
      index: "3",
      id: "exit"
    }));
  }

} //page toolbar/fab controller component

export class PageToolbarController extends BottomToolbarController {
  constructor(props) {
    super(props);
  }

  onMenuCommand(id) {
    if (this.props.onCommand) this.props.onCommand(id);
  }

  enableCreateDialogAccept() {
    this.createDialog.enableAccept();
  }

  render() {
    if (!this.props.authorized) return null;
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(PageToolbar, {
      active: this.state.toolbar.active,
      onButtonCommand: this.onButtonCommand.bind(this),
      onMenuCommand: this.onMenuCommand.bind(this),
      mode: this.props.mode
    }), /*#__PURE__*/React.createElement(MDCFabButton, {
      icon: "edit",
      onClick: this.onFabClick.bind(this),
      ref: ref => this.fabButton = ref,
      hide: this.props.showToolbar
    }), /*#__PURE__*/React.createElement(MDCSnackBar, {
      ref: ref => this.snackbar = ref
    }), /*#__PURE__*/React.createElement(MDCDialog, {
      ref: ref => this.createDialog = ref,
      onDialogAccept: this.props.onCreateDialogAccept,
      onDialogCancel: this.props.onCreateDialogCancel,
      accept: "Create",
      cls: "large-dialog",
      header: "Create Page"
    }, /*#__PURE__*/React.createElement(PageCreate, {
      ref: ref => this.pageCreate = ref,
      enableDialogAccept: this.enableCreateDialogAccept.bind(this)
    })), /*#__PURE__*/React.createElement(MDCDialog, {
      ref: ref => this.settingsDialog = ref,
      onDialogAccept: this.props.onSettingsDialogAccept,
      onDialogCancel: this.props.onSettingsDialogCancel,
      accept: "Save",
      cls: "large-dialog",
      header: "Page Settings"
    }, /*#__PURE__*/React.createElement(PageSettings, {
      ref: ref => this.pageSettings = ref
    })), this.props.children);
  }

}
export default {
  PageToolbar,
  PageToolbarController
};